import { Account, Company, CompanyAiClassification, CompanyCeoDetail, CompanyDetail, Period, Workspace } from "../types/interfaces";

export default class CompanyInfo {
    constructor() { }

    public company?: Company;
    public companyDetail?: CompanyDetail;
    public companyCeoDetail?: CompanyCeoDetail;
    public accountingPeriod?: Period;
    public companyAiClassification?: CompanyAiClassification;
    public workspace?: Workspace;
    public periodList?: Period[];
    public accountList?: Account[];
    public updateAccountList?: (updater: (accounts: Account[]) => Account[]) => void;
}